import { Check, Circle } from "lucide-react";
import { PASSWORD_RULES } from "@/lib/passwordValidation";

type PasswordRequirementsProps = {
  password: string;
  showWhenEmpty?: boolean;
};

export const PasswordRequirements = ({
  password,
  showWhenEmpty = false,
}: PasswordRequirementsProps) => {
  if (!password && !showWhenEmpty) return null;

  return (
    <div
      className="rounded-md border border-black/10 bg-[#f8fafc] px-4 py-3 space-y-2"
      data-testid="password-requirements"
    >
      <p className="text-xs font-mono-acc uppercase tracking-[0.15em] text-vg-gray">
        Password requirements
      </p>
      <ul className="space-y-1.5">
        {PASSWORD_RULES.map((rule) => {
          const met = password.length > 0 && rule.test(password);
          const pending = password.length === 0;

          return (
            <li
              key={rule.id}
              className="flex items-start gap-2 text-sm"
              data-testid={`password-rule-${rule.id}`}
              data-met={met ? "true" : "false"}
            >
              {met ? (
                <Check size={16} className="shrink-0 text-green-600 mt-0.5" strokeWidth={2.5} />
              ) : (
                <Circle
                  size={16}
                  className={`shrink-0 mt-0.5 ${pending ? "text-vg-gray/40" : "text-red-400"}`}
                  strokeWidth={2}
                />
              )}
              <span className={met ? "text-green-700" : pending ? "text-vg-gray" : "text-vg-ink"}>
                {rule.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
